// @flow
import { connect } from 'react-redux';
import LineTermination from './LineTermination';
import { hasVisibleSubscriptionsSelector } from '../../modules/Dashboard';

import type { StateType } from '../../modules/reducers';
import type { StateProps } from './LineTermination';

const mapStateToProps = (state: StateType): StateProps => ({
  hasVisibleSubscriptions: hasVisibleSubscriptionsSelector(state),
});

export default connect(mapStateToProps)(LineTermination);
